import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchFederation as fetchFederationAPI,
         fetchFederations as fetchFederationsAPI, 
         updateFederation as updateFederationAPI
         } from '../../services/federationService';

const initialState = {
  federation: {},
  federations: [],
  loading: false,
  error: null,
};

export const fetchFederation = createAsyncThunk('federations/fetchFederation', async (id, { rejectWithValue }) => {
  try {
    const response = await fetchFederationAPI(id);
    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Error al obtener la federación');
  }
});

export const fetchFederations = createAsyncThunk(
  'federations/fetchFederations',
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchFederationsAPI();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al obtener federaciones');
    }
  }
);

export const updateFederation = createAsyncThunk(
  'federations/updateFederation',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await updateFederationAPI(id, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al modificar la federación');
    }
  }
);

const federationSlice = createSlice({
  name: 'federations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      //GET Federation
      .addCase(fetchFederation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFederation.fulfilled, (state, action) => {
        state.loading = false;
        state.federation = action.payload;
      })
      .addCase(fetchFederation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //GET Federations
      .addCase(fetchFederations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFederations.fulfilled, (state, action) => {
        state.loading = false;
        state.federations = action.payload;
      })
      .addCase(fetchFederations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //Update Federation
      .addCase(updateFederation.fulfilled, (state, action) => {
        state.federation = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(updateFederation.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateFederation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Error al actualizar la federación';
      })
  },
});

export default federationSlice.reducer;
